import { render } from "./QRIcon.vue?vue&type=template&id=58e49a94&scoped=true"
const script = {}

import "./QRIcon.vue?vue&type=style&index=0&id=58e49a94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e49a94"]])

export default __exports__